module.exports = __webpack_public_path__ + "img/diamond.a60ee67c.svg";